// 公共常量

// 默认语言
export const DEFAULT_LANGUAGE = 'zh-CN';

export const HEADER_KEY_SITE = 'X-Matrix-Site-Code';
export const HEADER_KEY_LANGUAGE = 'X-Matrix-Locale';
export const HEADER_KEY_TOKEN = 'X-Matrix-Token';

// Token Key
export const TOKEN_KEY = 'spop_legal_api_token';

export const SITE_CODE = 'foss-legal';
